import React, {useState, useEffect} from 'react';
import Rater from 'react-rater';
import Star from './star';

import './index.less';

export default function (props) {
  const [txt, setTxt] = useState('');

  useEffect(() => {
    mapTxt(props.rate);
  }, []);

  const onRate = e => {
    console.log('aaa', e);
    const {rating} = e;
    mapTxt(rating);
    props.onRate(rating);
  };

  function mapTxt(rating) {
    const {rateText=[]} = props;
    if (rating >= 1 && rating < 3) {
      setTxt(rateText[0] || '差评');
    } else if (rating >= 3 && rating < 5) {
      setTxt(rateText[1] || rateText[0] || '中评');
    } else if (rating >= 5) {
      setTxt(rateText[2] || rateText[1] || rateText[0] || '好评');
    } else {
      setTxt('');
    }
  }

  return (
    <section className="cmt-rate">
      <Rater total={5} rating={props.rate} interactive={true} onRate={e => onRate(e)}>
        <Star />
      </Rater>
      {txt ? <span className="cmt-rate-status">{txt}</span> : ''}
    </section>
  );
}
